
import PropTypes from 'prop-types'
import React from 'react'

const Warning = props => {
  const {
    display,
    color,
    height,
    width,
    viewBox,
    margin
  } = props

  const styles = {
    display,
    margin,
    fill: color
  }

  return (
    <svg style={styles} width={width} height={height} viewBox={viewBox}>
      <g fill={color} fillRule='evenodd'>
        <path d='M10 18.25A8.25 8.25 0 0 1 1.75 10 8.25 8.25 0 1 1 10 18.25zm0-18C4.614.25.25 4.615.25 10s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S15.385.25 10 .25z' />
        <path d='M9 11a1 1 0 0 0 2 0V5a1 1 0 0 0-2 0v6zM9 15a1 1 0 1 0 2.001-.001A1 1 0 0 0 9 15' />
      </g>
    </svg>
  )
}

Warning.defaultProps = {
  display: 'block',
  color: 'currentColor',
  height: '20',
  width: '20',
  viewBox: '0 0 20 20',
  margin: '0'
}

Warning.propTypes = {
  display: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  height: PropTypes.oneOfType([ PropTypes.number, PropTypes.string ]).isRequired,
  width: PropTypes.oneOfType([ PropTypes.number, PropTypes.string ]).isRequired,
  viewBox: PropTypes.string.isRequired,
  margin: PropTypes.string.isRequired
}

Warning.displayName = 'Warning'

export default Warning



// WEBPACK FOOTER //
// ./ui/icons/warning.js